/**
 * PAS module route manifest (ProActive Solution corporate website).
 *
 * Each route is mounted under the shell's main-layout when this module is active
 * (selected by APP_CODE). The shell never knows about PAS pages beyond this file.
 *
 * Site « one-page » : À propos, Compétences, Emploi et Contact sont des sections de
 * /pas-portal (cf. components/pas/pasNav.js) ; leurs anciennes URL redirigent vers
 * l'ancre correspondante. Les pages produit restent des pages séparées.
 */
export default {
  code: 'pas',
  alwaysMounted: true, // corporate website — accessible quel que soit APP_CODE
  routes: [
    {
      path: '/pas-portal',
      name: 'pas-portal',
      component: () => import('@pas-pages/portal/pasPortal.vue'),
      meta: { appCode: 'pas', public: true, portal: true, title: 'ProActive Solution' }
    },
    {
      // Ancienne page « À propos » : désormais section #about du portail one-page.
      path: '/pas-about',
      name: 'pas-about',
      redirect: { path: '/pas-portal', hash: '#about' },
      meta: { appCode: 'pas', public: true, portal: true }
    },
    {
      path: '/pas-gstar',
      name: 'pas-gstar',
      component: () => import('@pas-pages/portal/pasGstar.vue'),
      meta: { appCode: 'pas', public: true, portal: true, title: 'Gstar' }
    },
    {
      path: '/pas-pro-nova',
      name: 'pas-pro-nova',
      component: () => import('@pas-pages/portal/pasProNova.vue'),
      meta: { appCode: 'pas', public: true, portal: true, title: 'ProNova' }
    },
    {
      path: '/pas-modular',
      name: 'pas-modular',
      component: () => import('@pas-pages/portal/pasModular.vue'),
      meta: { appCode: 'pas', public: true, portal: true, title: 'Modular' }
    },
    {
      path: '/pas-comete',
      name: 'pas-comete',
      component: () => import('@pas-pages/portal/pasComete.vue'),
      meta: { appCode: 'pas', public: true, portal: true, title: 'Comète' }
    },
    {
      // Ancienne page « Compétences » : désormais section #skills du portail one-page.
      path: '/pas-skills',
      name: 'pas-skills',
      redirect: { path: '/pas-portal', hash: '#skills' },
      meta: { appCode: 'pas', public: true, portal: true }
    },
    {
      // Ancienne page « Emploi » : désormais section #jobs du portail one-page.
      path: '/pas-jobs',
      name: 'pas-jobs',
      redirect: { path: '/pas-portal', hash: '#jobs' },
      meta: { appCode: 'pas', public: true, portal: true }
    },
    {
      // Ancienne page « Contact » : désormais section #contact du portail one-page.
      path: '/pas-contact',
      name: 'pas-contact',
      redirect: { path: '/pas-portal', hash: '#contact' },
      meta: { appCode: 'pas', public: true, portal: true }
    },
  ]
}
